export const logoRegistry = {
    defence24: {
        default: require('@client-assets/images/logotypes/border-bottom/light/defence-24.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/defence-24.svg')
    },
    cyberdefence24: {
        default: require('@client-assets/images/logotypes/border-bottom/light/cyber-defence-24.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/cyber-defence-24.svg')
    },
    energetyka24: {
        default: require('@client-assets/images/logotypes/border-bottom/light/energetyka-24.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/energetyka-24.svg')
    },
    infosecurity24: {
        default: require('@client-assets/images/logotypes/border-bottom/light/info-security-24.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/info-security-24.svg')
    },
    space24: {
        default: require('@client-assets/images/logotypes/border-bottom/light/space-24.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/space-24.svg')
    },
    'defence24-com': {
        default: require('@client-assets/images/logotypes/border-bottom/light/defence-24-com.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/defence-24-com.svg')
    },
    'sklep-d24': {
        default: require('@client-assets/images/logotypes/border-bottom/light/sklep-defence-24.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/sklep-defence-24.svg')
    },
    'karta-mundurowa': {
        default: require('@client-assets/images/logotypes/border-bottom/light/karta-mundurowa.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/karta-mundurowa.svg')
    },
    academy24: {
        default: require('@client-assets/images/logotypes/border-bottom/light/defence-academy-24.svg'),
        grayscale: require('@client-assets/images/logotypes/border-bottom/grayscale/defence-academy-24.svg')
    }
};
